import { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  Avatar,
  Typography,
  Button,
  Divider,
  Grid,
  useTheme,
  Box,
} from '@mui/material';

import ShowTicketOpen from '../ShowTicketOpenModal';

import { AuthContext } from '../../context/Auth/AuthContext';
import { FormatMask } from '../../utils/FormatMask';
import { isNil } from 'lodash';
import toastError from '../../toasts/toastError';
import api from '../../services/api';

import noPicture from '../../assets/nopicture.png';

const VcardPreview = ({ contact, numbers, queueId, whatsappId }) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);

  const companyId = user.companyId;

  const [openAlert, setOpenAlert] = useState(false);
  const [userTicketOpen, setUserTicketOpen] = useState('');
  const [queueTicketOpen, setQueueTicketOpen] = useState('');
  const format = new FormatMask();

  const [selectedContact, setContact] = useState({
    id: 0,
    name: '',
    number: 0,
    profilePicUrl: '',
  });

  useEffect(() => {
    const fetchContacts = async () => {
      try {
        if (isNil(numbers)) {
          return;
        }
        const number = numbers.replace(/\D/g, '');

        const getData = await api.get(`/contacts/profile/${number}`);

        console.log(getData);

        if (getData.data.contactId && getData.data.contactId !== 0) {
          let obj = {
            id: getData.data.contactId,
            name: contact,
            number: numbers,
            profilePicUrl: getData.data.profilePicUrl,
          };

          setContact(obj);
        } else {
          let contactObj = {
            name: contact,
            number: number,
            email: '',
            companyId: companyId,
          };

          const { data } = await api.post('/contacts', contactObj);
          setContact(data);
        }
      } catch (err) {
        console.error(err);
        toastError(err);
      }
    };
    fetchContacts();
  }, [companyId, contact, numbers]);

  const handleCloseAlert = () => {
    setOpenAlert(false);
    setOpenAlert(false);
    setUserTicketOpen('');
    setQueueTicketOpen('');
  };

  const handleNewChat = async () => {
    try {
      const { data: ticket } = await api.post('/tickets', {
        contactId: selectedContact.id,
        userId: user.id,
        status: 'open',
        queueId,
        companyId: companyId,
        whatsappId,
      });

      navigate(`/tickets/${ticket.uuid}`);
    } catch (err) {
      const showError = (err) => {
        const formatted = (
          err?.response?.data?.error ||
          err.message ||
          'Erro desconhecido'
        ).replace(/\n/g, '<br />');

        toastError(<div dangerouslySetInnerHTML={{ __html: formatted }} />, {
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: 'dark',
        });
      };
      showError(err);
    }
  };

  return (
    <>
      <div
        style={{
          minWidth: '250px',
        }}
      >
        <ShowTicketOpen
          isOpen={openAlert}
          handleClose={handleCloseAlert}
          user={userTicketOpen}
          queue={queueTicketOpen}
        />
        <Grid
          container
          spacing={1}
          sx={{
            border: 'solid 1px #bdbdbd73',
            borderRadius: '5px',
            padding: '5px',
            backgroundColor: '#eeeeee34',
          }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignContent: 'center',
              width: '100%',
            }}
          >
            <Avatar
              src={selectedContact.urlPicture || noPicture}
              sx={{ transform: 'translateY(35%) scale(1.2)' }}
            />
            <Typography
              sx={{
                marginTop: '12px',
                marginLeft: '10px',
                color: theme.custom.colors.text,
              }}
              variant='subtitle1'
              gutterBottom
            >
              {selectedContact.name}
              <Box
                component='span'
                display='flex'
                sx={{ fontSize: '10px', justifyContent: 'center' }}
              >
                {format.setPhonePatternMask(selectedContact.number)}
              </Box>
            </Typography>
          </div>
          <Grid size={{ xs: 12 }}>
            <Divider sx={{ backgroundColor: '#bdbdbd73' }} />
            <Button
              fullWidth
              onClick={handleNewChat}
              disabled={!selectedContact.number}
              sx={{ color: theme.custom.colors.text }}
            >
              Conversar
            </Button>
          </Grid>
        </Grid>
      </div>
    </>
  );
};

export default VcardPreview;
